import { LoadSpinner } from '@calizahq/react-components-v2'
import { usePotentialBookingFiltersContext } from '@sales-app/context/potentialBookingFilters/potentialBookingFilters'
import { DisplayCitiesQueries } from '@sales-app/graphql/queries/displayCities.queries'
import { DisplayCity } from '@sales-app/types/DisplayCity'
import { useDebounce } from '@shared/hooks'
import React, { ChangeEvent, useState } from 'react'

import { Dropdown } from '@/components'
import { FilterOptionsStyled } from '@/components/ListFilter/FilterOptionsStyled'
import { useGraphql } from '@/hooks/useGraphql'

export const DisplayCityFilter = () => {
  const { displayCity, setFilters } = usePotentialBookingFiltersContext()
  const [dropdownExpanded, setDropdownExpanded] = useState(false)
  const [searchString, setSearchString] = useState<string>()
  const debouncedSearch = useDebounce(searchString, 1000)
  const { data, isLoading } = useGraphql<DisplayCitiesQueries.GET_DISPLAY_CITIES.Response>(
    DisplayCitiesQueries.getDisplayCities.name,
    DisplayCitiesQueries.getDisplayCities(),
    {
      filter: { name: debouncedSearch },
    },
  )
  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  const changeFilter = (val: DisplayCity | null = null) => {
    setDropdownExpanded(false)
    if (val) {
      setFilters({ displayCity: val })
    } else {
      setFilters({ displayCity: null, unassigned: null })
    }
  }

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setSearchString(e.target.value)
  }

  const headerTitle = displayCity ? `${displayCity.name}, ${displayCity.regionAbbreviation}` : 'Market'

  return (
    <Dropdown
      className="hidden w-full md:w-auto lg:flex"
      expanded={dropdownExpanded}
      headerTitle={headerTitle}
      onHideDropdown={handleCancel}
      renderHeader={() => <div></div>}
      selected={!!displayCity}
      setExpanded={setDropdownExpanded}
    >
      <FilterOptionsStyled>
        <div className="flex w-full px-4">
          <input
            autoComplete="off"
            className="mb-2  w-full rounded border-2 border-border-secondary p-2 focus:outline-none"
            onChange={handleSearch}
            placeholder="Search"
            value={searchString || ''}
          />
        </div>
        <div className="flex w-full">
          {isLoading ? (
            <div className="flex h-24 w-full items-center justify-center">
              <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
            </div>
          ) : (
            <div className="flex max-h-48 min-h-24 w-full overflow-scroll">
              {data && data?.displayCities?.length && (
                <ul>
                  <li
                    className={`${!displayCity ? 'selected' : ''}`}
                    onClick={() => changeFilter()}
                    role={'presentation'}
                  >
                    All
                  </li>

                  {data?.displayCities.map((city) => (
                    <li
                      className={`${city.id === displayCity?.id ? 'selected' : ''}`}
                      key={city.id}
                      onClick={() => changeFilter(city)}
                      role={'presentation'}
                    >
                      {city.name || ''}, {city.regionAbbreviation}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
      </FilterOptionsStyled>
    </Dropdown>
  )
}
